import Grid from '@blocks/Grid'
import React from 'react'

export default function FinishedBestAuthor({ user }: Props) {
    const name = user ? `${user.first_name} ${user.last_name}` : "Not chosen."

    return (
        <Grid gap="5px">
            <small>Best Author</small>
            <h4>{name}</h4>
        </Grid>
    )
}

interface Props {
    user: Interfaces.Customer | null
}